import { render, staticRenderFns } from "./RouteViolationsDialog.vue?vue&type=template&id=1f7af4ba&scoped=true&"
import script from "./RouteViolationsDialog.vue?vue&type=script&lang=js&"
export * from "./RouteViolationsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7af4ba",
  null
  
)

export default component.exports